import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { StyledButton } from 'components/Buttons';
import { useTranslation } from 'react-i18next';
import * as S from '../../InvoiceLinesPanel.css';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
};

export const ClearCorrectionDialog = ({ open, onClose, onSubmit }: Props) => {
  const { t } = useTranslation(['misc', 'invoice']);

  const handleSubmit = async () => {
    onClose();
    await onSubmit();
  };

  return (
    <S.StyledDialog open={open} onClose={onClose}>
      <DialogTitle>
        {t('modal.clearCorrectionRequiredMarkingHeading', { ns: 'misc' })}
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          {t('modal.clearCorrectionRequiredMarkingBody', { ns: 'misc' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton $primary onClick={handleSubmit}>
          {t('button.reject', { ns: 'misc' })}
        </StyledButton>
        <StyledButton onClick={onClose}>
          {t('button.cancel', { ns: 'misc' })}
        </StyledButton>
      </DialogActions>
    </S.StyledDialog>
  );
};
